import { MembershipCard } from '../../membership-card/models/membership-card.interfaces';
import { Card, DisplayProperties } from '@com-delta-idp/mnx-skymiles-shared';

export interface QuickLinks extends DisplayProperties {
  title: string;
  cards: Card[];
  membershipCard: MembershipCard;
}
